module.exports = "/_next/static/images/ae91e0388604210ff81348d086437ab9-bubble-gum-woman-square@xs-2x.jpg.webp";